import React from 'react';
import { useScrollTop } from '../../../hooks/useScrollTop';
import { useFormState } from 'contexts/FormProvider';

import { FormCard } from '@qbe/ads-blocks-forms';
import { useContent, useContentContext } from '@qbe/dfc-content';

const SuccessPage = () => {
  useScrollTop();
  const { formData } = useFormState();
  const getLodgementOption = (value: string) => formData?.lodgement === value;

  const { getTextContent } = useContent({
    context: useContentContext(),
  });

  // Localized content constants
  const pageTitle = getTextContent('success.form.title');
  const defaultDescription = getTextContent('success.form.content');
  const complimentDescription = getTextContent('compliment.details.success');

  return (
    <FormCard
      variant="pageTitle"
      title={pageTitle}
      description={
        getLodgementOption('Complaint') || getLodgementOption('Financial hardship application')
          ? defaultDescription
          : complimentDescription
      }
    />
  );
};

export default SuccessPage;
